import Page from "@scripts/page";

export default class stickyPost extends Page {
    constructor() {
        super();
        document.addEventListener('DOMContentLoaded', () => {
            const stickyPostContainerAll = document.querySelectorAll<HTMLElement>('.sticky-post');
            const blog = document.querySelectorAll('.blog');

            if (stickyPostContainerAll.length) {
                stickyPostContainerAll.forEach($stickyPost => {
                    this.init($stickyPost);
                });
            }

            /*if (blog.length) {
                const $loopContainer = document.querySelector<HTMLElement>('.wings-loop-container');
                this.updateImageDimensions(<HTMLElement>$loopContainer, '.entry-image img');
                console.log('blog.ts');
            }*/
        }, false);
    }

    init ($stickyPost: HTMLElement) {
        this.updateStickyPostImageDimensions($stickyPost);
    }

    updateStickyPostImageDimensions($stickyPost: HTMLElement) {
        const $image = <HTMLImageElement>$stickyPost.querySelector<HTMLImageElement>('.entry-image img');
        if (screen.width > 768) {
            if ($image.width < $image.height) {
                $image.style.height = '100%';
            } else {
                $image.style.width = '100%';
            }
        } else {
            $image.style.width = 'auto';
            $image.style.height = 'auto';
        }

    }
}
